import { createAppSwitcher } from '@tesla/design-system';
import { iconArrowSmall270, iconChevronSmall180, iconGrid, iconRows, } from '@tesla/design-system-icons';
import React, { useEffect, useRef } from 'react';
import { FormInputSearch, Icon, IconButton, Tab, TabList } from '../index.js';
export const AppSwitcher = (props) => {
    var _a;
    const appSwitcher = useRef(null);
    useEffect(() => {
        if (appSwitcher === null || appSwitcher === void 0 ? void 0 : appSwitcher.current)
            /*
              Create the AppSwitcher by passing in a container reference and the props.
              This will handle all of the logic for manipulating the DOM.
      
              From the React side, we just have to pass in the reference to the AppSwitcher container, and the props needed to createAppSwitcher().
              We also need to make sure the necessary elements in the template are available.
      
              This is different than the traditional way of making React components, but makes it so that the
              functionality can be shared and used across multiple frameworks.
            */
            createAppSwitcher(appSwitcher.current, props);
    }, [appSwitcher, props]);
    // Template needed for createAppSwitcher()
    // Future goal is to remove the template entirely and use a web component
    return (React.createElement("div", { ref: appSwitcher, className: "tds-app-switcher tds-density--dense" },
        React.createElement("div", { className: "tds-menu" },
            React.createElement("div", { className: "tds-tooltip-wrapper" },
                React.createElement("button", { className: "tds-menu-btn", "data-tds-tooltip-trigger": "true" },
                    React.createElement("div", { className: "tds-app-title" },
                        React.createElement("span", { className: "tds-app-title-text" }),
                        React.createElement(Icon, { data: iconChevronSmall180 }))),
                React.createElement("div", { className: "tds-tooltip tds-tooltip--orientation-down", role: "tooltip" },
                    React.createElement("div", { className: "tds-app-switcher-layout tds--is_hidden" },
                        React.createElement("div", { className: "tds-app-switcher-toolbar" },
                            React.createElement("div", { className: "tds-app-switcher-search" },
                                React.createElement(FormInputSearch, { placeholder: "Search" })),
                            React.createElement("div", { className: "tds-app-switcher-toggle" },
                                React.createElement(TabList, { className: "tds-tab-list--icons", variant: "toggle" },
                                    React.createElement(Tab, { id: "grid" },
                                        React.createElement(Icon, { data: iconGrid })),
                                    React.createElement(Tab, { id: "list" },
                                        React.createElement(Icon, { data: iconRows }))))),
                        React.createElement("div", { className: "tds-app-switcher-subapps-header" },
                            React.createElement(IconButton, { className: "tds-app-switcher-subapps-back" },
                                React.createElement(Icon, { data: iconArrowSmall270 })),
                            React.createElement("strong", { className: "tds-app-switcher-subapps-title" })),
                        React.createElement("div", { className: "tds-app-switcher-apps" }),
                        React.createElement("div", { className: "tds-app-switcher-subapps" }),
                        React.createElement("div", { className: "tds-app-switcher-search-results" }),
                        React.createElement("div", { className: "tds-app-switcher-noapps" }, (_a = props.errorMessage) !== null && _a !== void 0 ? _a : (React.createElement(React.Fragment, null,
                            React.createElement("h6", null, "No Applications Available"),
                            React.createElement("p", { className: "tds-text--caption" },
                                "This may be due to a system error.",
                                React.createElement("br", null),
                                "Reload to try again."))))))))));
};
